import React from 'react'
import Head from 'next/head'

interface MetaDescriptionProps {
  content: string
}

const MetaDescription: React.FC<MetaDescriptionProps> = ({ content }) => (
  <Head>
    <meta name="description" key="description" content={content} />
  </Head>
)

export default MetaDescription
